import editorModel from '../data/editorModel';
const SITE_CREATION_TEMPLATE_ID = '6e51b1b9-0fa7-42df-9637-771a4543f4f4';
// duplicated to '@/main/startup/sectionsExperience'
export const isSiteCreationSectionsTemplate = () => {
    const { originalTemplateId } = editorModel.siteHeader;
    return originalTemplateId === SITE_CREATION_TEMPLATE_ID;
};
